import { createAction, props } from '@ngrx/store';
import { EventState } from '../reducers/event.reducer';

export const upsertEvent = createAction('[Events Page] Upsert', props<EventState>());
